// import React from "react";

// export default function Annexure5(props) {
//   return (
//     <div>
//       <h1 className="text-3xl font-bold mb-6 text-yellow-500">Annexure-5</h1>

//       <div className="space-y-5">
//         <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
//           <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">
//             Poor Practice Issues and Child Safeguarding & Protection Concerns
//             Reporting Form
//           </h2>
//           <ul className="space-y-2 mb-4">
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">1.</span>
//               <span className="text-gray-700">
//                 Report is on ( ) Poor Practice ( ) Child Protection Concern ( )
//                 Not sure
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">2.</span>
//               <span className="text-gray-700">
//                 Date of incidence: ___ / ___ / ___
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">3.</span>
//               <span className="text-gray-700">
//                 Location of incidence: ____________________
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">4.</span>
//               <span className="text-gray-700">
//                 Time of incidence: ___________________
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">5.</span>
//               <span className="text-gray-700">
//                 Please provide below details to the best possible extent.
//               </span>
//             </li>
//           </ul>

//           <ul className="space-y-4 ml-5 mb-4">
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">a)</span>
//               <span className="text-gray-700 block mb-20">
//                 Please briefly mention the poor practice or Child protection
//                 concern and how it has affected the child.
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">b)</span>
//               <span className="text-gray-700 block mb-20">
//                 Available details of the affected child (Name, child’s/parent’s
//                 mobile number address, school, class)
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">c)</span>
//               <span className="text-gray-700">
//                 Did you witness the reported incidence/ concern? Yes/ No
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">d)</span>
//               <span className="text-gray-700 block mb-20">
//                 If no, who told you about it: (Name, mobile number, address)
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 mb-20">e)</span>
//               <span className="text-gray-700">
//                 Available details of eye witnesses: (Name, designation,
//                 organization, mobile number, address)
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">f)</span>
//               <span className="text-gray-700">
//                 Do you have any evidence or photos/ videos to help us take
//                 befitting action? Yes/ No
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 ">g)</span>
//               <span className="text-gray-700">
//                 Are you willing to share further details of the concern and the
//                 evidence or photos/ videos, if we contact you? Yes/ No
//               </span>
//             </li>
//             <li className="flex items-start">
//               <span className="text-yellow-500 mr-2 mb-20">h)</span>
//               <span className="text-gray-700">
//                 Any suggestions for improvement?
//               </span>
//             </li>
//           </ul>

//           <span className="text-gray-700 block mb-6">
//             <span className="text-yellow-500">6.</span>
//             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Your details
//             please:
//             <br />
//             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Name:
//             <br />
//             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Age:
//             <br />
//             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mobile/WhatsApp.:{" "}
//             <br />
//             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Address:{" "}
//             <br />
//             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Your
//             relationship with affected child: <br />
//           </span>

//           <span className="text-gray-700 block mb-4 ">
//             We thank you for your inputs which will help us take appropriate
//             action and strengthen our Child Safeguarding and Protection efforts.
//             We assure you of maintaining complete confidentiality.
//           </span>

//           <div className="flex justify-end">
//             <div className="flex flex-col">
//               <p className="text-gray-700">Pankaj Mahajan</p>
//               <p className="text-gray-700">
//                 Child Safeguarding & Protection Officer, Slum Soccer{" "}
//               </p>
//               <p className="text-gray-700">
//                 Mobile 9860556506 Email: pankaj.mahajan @slumsoccer.org{" "}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect } from "react";

export default function Annexure5(props) {
  // Load required scripts when component mounts
  useEffect(() => {
    // Load jsPDF
    const jsPDFScript = document.createElement('script');
    jsPDFScript.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    jsPDFScript.async = true;
    document.body.appendChild(jsPDFScript);

    // Load html2canvas
    const html2canvasScript = document.createElement('script');
    html2canvasScript.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
    html2canvasScript.async = true;
    document.body.appendChild(html2canvasScript);
    
    return () => {
      document.body.removeChild(jsPDFScript);
      document.body.removeChild(html2canvasScript);
    };
  }, []);

  // Function to handle the download action
  const handleDownload = () => {
    // Check if libraries are loaded
    if (typeof window.jspdf === 'undefined' || typeof window.html2canvas === 'undefined') {
      alert('PDF generator is loading. Please try again in a moment.');
      return;
    }
    
    // Create a temporary container for the form content
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = '-9999px';
    tempDiv.style.top = '-9999px';
    tempDiv.style.width = '210mm'; // A4 width
    
    // Add the content to be converted to PDF
    tempDiv.innerHTML = `
      <div style="font-family: Arial, sans-serif; padding: 20px; line-height: 1.5;">
        <h2 style="font-size: 18px; font-weight: bold; margin-bottom: 15px; text-align: center;">
          Poor Practice Issues and Child Safeguarding & Protection Concerns Reporting Form
        </h2>
        
        <ul style="padding-left: 0; list-style-type: none;">
          <li style="margin-bottom: 12px; display: flex;">
            <span style="color: #eab308; margin-right: 8px; min-width: 15px;">1.</span>
            <span>Report is on ( ) Poor Practice ( ) Child Protection Concern ( ) Not sure</span>
          </li>
          <li style="margin-bottom: 12px; display: flex;">
            <span style="color: #eab308; margin-right: 8px; min-width: 15px;">2.</span>
            <span>Date of incidence: ___ / ___ / ___</span>
          </li>
          <li style="margin-bottom: 12px; display: flex;">
            <span style="color: #eab308; margin-right: 8px; min-width: 15px;">3.</span>
            <span>Location of incidence: ____________________</span>
          </li>
          <li style="margin-bottom: 12px; display: flex;">
            <span style="color: #eab308; margin-right: 8px; min-width: 15px;">4.</span>
            <span>Time of incidence: ___________________</span>
          </li>
          <li style="margin-bottom: 12px; display: flex;">
            <span style="color: #eab308; margin-right: 8px; min-width: 15px;">5.</span>
            <span>Please provide below details to the best possible extent.</span>
          </li>
        </ul>
        
        <div style="margin-left: 25px;">
          <ul style="padding-left: 0; list-style-type: none;">
            <li style="margin-bottom: 12px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">a)</span>
              <span>Please briefly mention the poor practice or Child protection concern and how it has affected the child.</span>
            </li>
            <div style="min-height: 120px;"></div>
            
            <li style="margin-bottom: 12px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">b)</span>
              <span>Available details of the affected child (Name, child's/parent's mobile number address, school, class)</span>
            </li>
            <div style="min-height: 120px;"></div>
            
            <li style="margin-bottom: 12px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">c)</span>
              <span>Did you witness the reported incidence/ concern? Yes/ No</span>
            </li>
            
            <li style="margin-bottom: 12px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">d)</span>
              <span>If no, who told you about it: (Name, mobile number, address)</span>
            </li>
            <div style="min-height: 120px;"></div>
            
            <li style="margin-bottom: 12px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">e)</span>
              <span>Available details of eye witnesses: (Name, designation, organization, mobile number, address)</span>
            </li>
            <div style="min-height: 120px;"></div>
            
            <li style="margin-bottom: 12px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">f)</span>
              <span>Do you have any evidence or photos/ videos to help us take befitting action? Yes/ No</span>
            </li>
            
            <li style="margin-bottom: 12px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">g)</span>
              <span>Are you willing to share further details of the concern and the evidence or photos/ videos, if we contact you? Yes/ No</span>
            </li>
            
            <li style="margin-bottom: 12px; margin-top: 150px; display: flex;">
              <span style="color: #eab308; margin-right: 8px; min-width: 15px;">h)</span>
              <span>Any suggestions for improvement?</span>
            </li>
            <div style="min-height: 120px;"></div>
          </ul>
        </div>
        
        <p>
          <span style="color: #eab308; margin-right: 40px;">6.</span>
          Your details please:
        </p>
        <div style="margin-left: 60px; margin-bottom:16px;">
          <p>Name: ________________________________</p>
          <p>Age: _________________________________</p>
          <p>Mobile/WhatsApp.: _____________________</p>
          <p>Address: _____________________________</p>
          <p>Your relationship with affected child: _____________________</p>
        </div>
        
        <p>We thank you for your inputs which will help us take appropriate action and strengthen our Child Safeguarding and Protection efforts. We assure you of maintaining complete confidentiality.</p>
        
        <div style="margin-top: 20px; text-align: right;">
          <p>Pankaj Mahajan</p>
          <p>Child Safeguarding & Protection Officer, Slum Soccer</p>
          <p>Mobile 9860556506 Email: pankaj.mahajan@slumsoccer.org</p>
        </div>
      </div>
    `;
    document.body.appendChild(tempDiv);
    
    // Generate PDF using html2canvas and jsPDF
    window.html2canvas(tempDiv, {scale: 2}).then(canvas => {
      // Remove the temporary div
      document.body.removeChild(tempDiv);
      
      // Create PDF from canvas
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF('p', 'mm', 'a4');
      
      // Add the canvas to PDF
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
      
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      
      // Add additional pages if content is longer than one page
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      
      // Download the PDF
      pdf.save('Child_Safeguarding_Form.pdf');
    });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold text-yellow-500">Annexure-5</h1>
        <button 
          onClick={handleDownload}
          className="bg-yellow-500 hover:bg-yellow-600 text-white font-medium py-2 px-4 rounded-md flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Download Form
        </button>
      </div>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">
            Poor Practice Issues and Child Safeguarding & Protection Concerns
            Reporting Form
          </h2>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">1.</span>
              <span className="text-gray-700">
                Report is on ( ) Poor Practice ( ) Child Protection Concern ( )
                Not sure
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">2.</span>
              <span className="text-gray-700">
                Date of incidence: ___ / ___ / ___
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">3.</span>
              <span className="text-gray-700">
                Location of incidence: ____________________
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">4.</span>
              <span className="text-gray-700">
                Time of incidence: ___________________
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">5.</span>
              <span className="text-gray-700">
                Please provide below details to the best possible extent.
              </span>
            </li>
          </ul>

          <ul className="space-y-4 ml-5 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">a)</span>
              <span className="text-gray-700 block mb-20">
                Please briefly mention the poor practice or Child protection
                concern and how it has affected the child.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">b)</span>
              <span className="text-gray-700 block mb-20">
                Available details of the affected child (Name, child's/parent's
                mobile number address, school, class)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">c)</span>
              <span className="text-gray-700">
                Did you witness the reported incidence/ concern? Yes/ No
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">d)</span>
              <span className="text-gray-700 block mb-20">
                If no, who told you about it: (Name, mobile number, address)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 mb-20">e)</span>
              <span className="text-gray-700">
                Available details of eye witnesses: (Name, designation,
                organization, mobile number, address)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">f)</span>
              <span className="text-gray-700">
                Do you have any evidence or photos/ videos to help us take
                befitting action? Yes/ No
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">g)</span>
              <span className="text-gray-700">
                Are you willing to share further details of the concern and the
                evidence or photos/ videos, if we contact you? Yes/ No
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 mb-20">h)</span>
              <span className="text-gray-700">
                Any suggestions for improvement?
              </span>
            </li>
          </ul>

          <span className="text-gray-700 block mb-6">
            <span className="text-yellow-500">6.</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Your details
            please:
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Name:
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Age:
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mobile/WhatsApp.:{" "}
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Address:{" "}
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Your
            relationship with affected child: <br />
          </span>

          <span className="text-gray-700 block mb-4 ">
            We thank you for your inputs which will help us take appropriate
            action and strengthen our Child Safeguarding and Protection efforts.
            We assure you of maintaining complete confidentiality.
          </span>

          <div className="flex justify-end">
            <div className="flex flex-col">
              <p className="text-gray-700">Pankaj Mahajan</p>
              <p className="text-gray-700">
                Child Safeguarding & Protection Officer, Slum Soccer{" "}
              </p>
              <p className="text-gray-700">
                Mobile 9860556506 Email: pankaj.mahajan@slumsoccer.org{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}